module.exports = "../study/imgs/maps/Tokyo/S8/Ecosystem/Fagus/Tokyo_Fagus_GFDL_RCP85_End.png";